"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwDialog = _interopRequireWildcard(require("../cwdialog/CwDialog"));

var CwFlyout = function CwFlyout(props) {
  var setFlyoutPosition = function setFlyoutPosition() {
    var windowHeight = window.innerHeight / 2;
    var windowWidth = window.innerWidth / 2;

    if (props.xCoord <= windowWidth && props.yCoord <= windowHeight) {
      return _CwDialog.CwFlyoutPointerPosition.TOP_LEFT;
    }

    if (props.xCoord <= windowWidth && props.yCoord > windowHeight) {
      return _CwDialog.CwFlyoutPointerPosition.BOTTOM_LEFT;
    }

    if (props.xCoord > windowWidth && props.yCoord <= windowHeight) {
      return _CwDialog.CwFlyoutPointerPosition.TOP_RIGHT;
    }

    if (props.xCoord > windowWidth && props.yCoord > windowHeight) {
      return _CwDialog.CwFlyoutPointerPosition.BOTTOM_RIGHT;
    }
  };

  return _react.default.createElement(_CwDialog.default, (0, _extends2.default)({}, props, {
    "data-cwid": props.cwId,
    flyoutPointerPosition: setFlyoutPosition()
  }));
};

CwFlyout.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Array of buttons aligned in the bottom right corner
   */
  buttons: _propTypes.default.arrayOf(_propTypes.default.element),

  /**
   * The primary header of the flyout
   */
  header: _propTypes.default.string.isRequired,

  /**
   * Specifies the height of the flyout
   */
  height: _propTypes.default.number,

  /**
   * The secondary header of the flyout
   */
  subHeader: _propTypes.default.string,

  /**
   * Specifies the width of the flyout
   */
  width: _propTypes.default.number,

  /**
   * Specifies the x coordinate of the flyout
   */
  x: _propTypes.default.number,

  /**
   * Specifies the y coordinate of the flyout
   */
  y: _propTypes.default.number,

  /**
   * Specifies the z-index of the flyout
   */
  zIndex: _propTypes.default.number,

  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes.default.func
};
var _default = CwFlyout;
exports.default = _default;